import type { EreignisStatus, MassnahmenStatus, RisikoStatus, RiskClass } from "@iso27001/shared";

// One place for the status colours, shared by the lists and the dialog
// headers so a record looks the same in both.
export const ereignisStatusColor: Record<EreignisStatus, string> = { Offen: "blue", InBearbeitung: "yellow", Geschlossen: "green" };
export const massnahmeStatusColor: Record<MassnahmenStatus, string> = { Offen: "blue", InBearbeitung: "yellow", Erledigt: "green", Verworfen: "gray" };
export const risikoStatusColor: Record<RisikoStatus, string> = { Identifiziert: "blue", InBehandlung: "yellow", Akzeptiert: "green", Geschlossen: "gray" };
export const riskClassColor: Record<RiskClass, string> = { "mäßig": "green", "hoch": "yellow", "kritisch": "red" };
export const priorityColor = { niedrig: "gray", mittel: "yellow", hoch: "red" } as const;
